import { render } from "./PortStopsCard.vue?vue&type=template&id=1edbde0b&scoped=true"
import script from "./PortStopsCard.vue?vue&type=script&lang=js"
export * from "./PortStopsCard.vue?vue&type=script&lang=js"

import "./PortStopsCard.vue?vue&type=style&index=0&id=1edbde0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edbde0b"]])

export default __exports__